import { getElements } from '../../element.js'
import { ajaxButton } from '../../ajax.js'

export const init = () => {

  const shortcodes = getElements('tangible-live-meeting-join')

  for (let i = 0; i < shortcodes.length; i++) {

    const id = shortcodes[i].getAttribute('data-id')
    const meetingId = shortcodes[i].getAttribute('data-meeting-id')
    const occurrenceId = shortcodes[i].getAttribute('data-occurrence-id')
    const type = shortcodes[i].getAttribute('data-type')
    const registration = shortcodes[i].getAttribute('data-registration')

    ajaxButton(shortcodes[i], 'tangible_live_join_meeting_user', {
      id            : id,
      meeting_id    : meetingId,
      occurrence_id : occurrenceId,
      type          : type,
      registration  : registration !== 'false'
    }, data => {

      if ( ! data.join_url ) return location.reload()

      const response = window.open(data.join_url, '_blank')

      /**
       * If repsonse is null, is means redirection has been blocked
       * 
       * It seems to happen on firefox, has window.open does not happen directly inside
       * an onclick event, the redirection is blocked
       * 
       * As a workaround, we will use location.href in those case and will open the zoom link
       * in the current tab
       * 
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/open#return_value
       */
      if ( response === null ) location.href = data.join_url
    })
  }
}
